export default __webpack_public_path__ + "static/media/airplane_crash.5293fbf7.png";